// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"245d9b1c","108":"da995339","161":"f75cd11b","195":"30c3fea4","221":"846e53d8","288":"7ea9b06a","353":"a3df6178","367":"a7cc20d8","507":"ae2b528e","523":"4029230a","561":"6f011a60","675":"b9ec0d1b","748":"47bd78f8","774":"d0885585","785":"2a28552c","968":"97388f7e"}[chunkId] + ".chunk.js";
};